import axios, { AxiosResponse } from "axios";
import { Archive } from "./archive.type";
import ArchiveService = Archive.ArchiveService;
import { logFunction, sectionDeleteConfig, sectionEditConfig, sectionViewConfig } from "../../services/logs";

/**
 * Список контента в архиве
 */
export const getArchiveList = (
    serviceUrl: string,
    start = 0,
    searchParams: any,
): Promise<AxiosResponse<ArchiveService>> => {
    return logFunction({
        config: {
            ...sectionViewConfig,
            description: 'Получения списка контента в архиве',
        },
        wrapperFunction() {
            return axios.get<ArchiveService>(serviceUrl, {
                params: { start, ...searchParams }
            })
        },
    });
};

/**
 * Восстановить контент
 */
export const restoreContent = (serviceUrl, id: string): Promise<AxiosResponse<void>> => {
    return logFunction({
        config: {
            ...sectionEditConfig,
            description: 'Восстановление архива',
        },
        body: {
            id
        },
        wrapperFunction() {
            return axios.post<void>(serviceUrl, { id })
        }
    });
};

/**
 * Удалить из архива
 */
export const removeContent = (serviceUrl, id: string): Promise<AxiosResponse<void>> => {
    return logFunction({
        config: {
            ...sectionDeleteConfig,
            description: 'Удаление из архива',
        },
        wrapperFunction() {
            return axios.delete<void>(serviceUrl, {
                params: { id }
            });
        }
    });
};
